import baseApi from "./baseApi";
import moment from "moment";
export default {
    async getPlantData() {
        let request = await baseApi.createHttpRequest();
        let result = await request.get("/roster/plants");

        return result.data;
    },
    async getWeatherData(plantID, startDate, endDate) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get(`/roster/getPlantWeather?${[
            `PlantID=${plantID}`,
            `StartDate=${moment(startDate).format('YYYY-MM-DD')}`,
            `EndDate=${moment(endDate).format('YYYY-MM-DD')}`
        ].join("&")}`);

        return result.data;
    },
    async getFinancialYearCalendarsData() {
        let request = await baseApi.createHttpRequest();
        let result = await request.get(`/roster/financialYearCalendar`);

        return result.data;
    },
    async getCropLocationVarietyRosters(plantID, productCategoryIDs, startDate, endDate, cropLocationID) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get(`/roster/getCropLocationVarietyRosters?${[
            `PlantID=${plantID}`,
            `ProductCategoryIDs=${productCategoryIDs.join(',')}`,
            `StartDate=${moment(startDate).format('YYYY-MM-DD')}`,
            `EndDate=${moment(endDate).format('YYYY-MM-DD')}`,
            `CropLocationID=${cropLocationID}`
        ].join("&")}`);
        return result.data;
    },
    async updateCropLocationVarietyDayRosters(cropLocationVarietyDayRosters) {
        let request = await baseApi.createHttpRequest();
        let result = await request.post(`/roster/UpdateCropLocationVarietyDayRosters`, cropLocationVarietyDayRosters);

        return result.data;
    },
    async updateCropLocationDaysVarietyRosters(cropLocationVarietyDayRosterList) {
        let request = await baseApi.createHttpRequest();
        let result = await request.post(`/roster/UpdateCropLocationVarietyDaysRosters`, cropLocationVarietyDayRosterList);

        return result.data;
    },
    async getRosterTeamPlans(plantID, productCategoryIDs, startDate, endDate) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get(`/roster/getRosterTeamPlans?${[
            `PlantID=${plantID}`,
            `ProductCategoryIDs=${productCategoryIDs.join(',')}`,
            `StartDate=${moment(startDate).format('YYYY-MM-DD')}`,
            `EndDate=${moment(endDate).format('YYYY-MM-DD')}`
        ].join("&")}`);
        return result.data;
    },
    async cleanUpRosterTeamPlans(plantID, startDate, endDate) {
        let request = await baseApi.createHttpRequest();
        await request.post(`/roster/CleanUpRosterTeamPlans?${[
            `PlantID=${plantID}`,
            `StartDate=${moment(startDate).format('YYYY-MM-DD')}`,
            `EndDate=${moment(endDate).format('YYYY-MM-DD')}`
        ].join("&")}`);
    },
    async updateRosterTeamPlans(rosterTeamPlans) {
        let request = await baseApi.createHttpRequest();
        let result = await request.post(`/roster/UpdateRosterTeamPlans`, rosterTeamPlans);
        return result.data;
    },
    async loadTeamRosterResult(teamIDs, startDate, endDate) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get(`/roster/teamHasRosters?${[
            `TeamIDs=${teamIDs.join(',')}`,
            `StartDate=${moment(startDate).format('YYYY-MM-DD')}`,
            `EndDate=${moment(endDate).format('YYYY-MM-DD')}`
        ].join("&")}`);
        return result.data;
    }
}